import * as yup from 'yup';
import {
	getFormDefinition,
	useGovForm,
} from '@gov-design-system-ce/react-form-core';
import type { FormDefinition } from '@gov-design-system-ce/react-form-core';

export const GunListEmptyStep = (): FormDefinition<Record<string, never>> => {
	const formSchema = yup.object({});

	const formMethods = useGovForm<Record<string, unknown>>({
		formSchema,
		defaultValues: {},
	});

	return getFormDefinition({ formMethods, formSchema });
};
